// Auto-generated by vite-plugin-themes — do not edit
import type { ThemeManifest } from '@/types/site-config';

export const themes: ThemeManifest[] = [
  {
    "name": "arctic",
    "displayName": "Arctic",
    "description": "Frozen landscapes with cyan ice and aurora effects",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#00ace5",
      "background": "#f4fcff",
      "foreground": "#132139"
    },
    "hasEffects": true
  },
  {
    "name": "broadsheet",
    "displayName": "Broadsheet",
    "description": "Playfair Display masthead, Lora body, drop-caps, newspaper columns. Generous leading on cream stock with deep navy ink.",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#8b1e1e",
      "background": "#fdfaf1",
      "foreground": "#1a1f2e"
    },
    "hasEffects": true
  },
  {
    "name": "cyberpunk",
    "displayName": "Cyberpunk",
    "description": "Neon colors and glitch aesthetics with hot pink and cyan",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#c3228d",
      "background": "#faf9fa",
      "foreground": "#482659"
    },
    "hasEffects": true
  },
  {
    "name": "digitalmeow",
    "displayName": "Digital Meow",
    "description": "White background, near-black body text, and muted cerulean links — modeled after Independent Publisher 2 on digitalmeow.com",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#0087be",
      "background": "#ffffff",
      "foreground": "#333332"
    },
    "hasEffects": false
  },
  {
    "name": "forest",
    "displayName": "Forest",
    "description": "Earth tones and natural palette with earthy greens and golden accents",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#2d9e53",
      "background": "#f1f7f1",
      "foreground": "#13391f"
    },
    "hasEffects": true
  },
  {
    "name": "editorial",
    "displayName": "Magazine Editorial",
    "description": "Source Serif Pro body, wide measure, essay-grade leading. Ink on warm paper with a rust accent — feels like a long-read print feature.",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#9a3412",
      "background": "#faf7f2",
      "foreground": "#1c1917"
    },
    "hasEffects": true
  },
  {
    "name": "monochrome",
    "displayName": "Monochrome",
    "description": "Clean, minimal monochrome palette with off-white and slate tones",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#3c83f5",
      "background": "#f7f9fb",
      "foreground": "#334156"
    },
    "hasEffects": false
  },
  {
    "name": "ocean",
    "displayName": "Ocean",
    "description": "Deep blues and aquatic palette with aqua and teal accents",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#2280c3",
      "background": "#e1edf3",
      "foreground": "#143251"
    },
    "hasEffects": true
  },
  {
    "name": "terminal",
    "displayName": "Terminal Journal",
    "description": "Phosphor-green on CRT black, Fira Code everywhere, bracketed [meta] tags and a faint scanline. Personal-site-as-dotfile.",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#3dff7a",
      "background": "#0b0f0b",
      "foreground": "#c8f7c8"
    },
    "hasEffects": true
  },
  {
    "name": "risograph",
    "displayName": "Zine Risograph",
    "description": "DM Sans display, Redaction body, risograph pink + blue duotone with a paper-grain overlay. Print-zine energy.",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#ff5a8a",
      "background": "#f7f3e9",
      "foreground": "#202b5c"
    },
    "hasEffects": true
  }
];

export const themeNames = ['arctic', 'broadsheet', 'cyberpunk', 'digitalmeow', 'forest', 'editorial', 'monochrome', 'ocean', 'terminal', 'risograph'] as const;

export type ThemeName = (typeof themeNames)[number];
